// import React, { useEffect, useState } from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import axios from "axios";
// import L from "leaflet";

// const JobMap = () => {
//   const [jobs, setJobs] = useState([]);
//   const [locations, setLocations] = useState({});

//   // Function to offset markers significantly to make them more visible
//   const randomOffset = () => (Math.random() - 0.5) * 0.25; // Increased offset value

//   // Fetch jobs
//   useEffect(() => {
//     axios.get("http://localhost:5000/available-jobs")
//       .then((response) => setJobs(response.data))
//       .catch((err) => console.error("Error fetching jobs:", err));
//   }, []);

//   // Fetch city coordinates from the new API
//   useEffect(() => {
//     axios.get("http://localhost:5000/job-locations-coords")
//       .then((response) => {
//         const locationMap = {};
//         response.data.forEach(({ city_name, latitude, longitude }) => {
//           if (latitude && longitude) {
//             locationMap[city_name] = { lat: latitude, lng: longitude };
//           }
//         });
//         setLocations(locationMap);
//       })
//       .catch((err) => console.error("Error fetching locations:", err));
//   }, []);

//   return (
//     <MapContainer center={[43.0, 17.5]} zoom={7} style={{ height: "500px", width: "100%" }}>
//       <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//       {jobs.map((job) => {
//         const jobLocation = locations[job.job_location];

//         if (!jobLocation) {
//           console.warn(`Skipping job "${job.job_name}" - No coordinates found for: ${job.job_location}`);
//           return null;
//         }

//         return (
//           <Marker
//             key={job.id}
//             position={[
//               jobLocation.lat + randomOffset(),
//               jobLocation.lng + randomOffset()
//             ]}
//             icon={L.icon({
//               iconUrl: "https://leafletjs.com/examples/custom-icons/leaf-red.png",
//               iconSize: [25, 41],
//               iconAnchor: [12, 41],
//               popupAnchor: [1, -34],
//             })}
//           >
//           <Popup>
//             <div >
//               <strong style={{ color: 'green'}}>
//                 {job.job_name.length > 30 
//                   ? job.job_name.substring(0, 30) + '...'
//                   : job.job_name}
//               </strong>
//               <br />
//               <b>LOCATION:</b> {job.job_location}
//               <br />
//               <b>TYPE:</b> {job.job_type}
//               <br />
//               <a 
//                 href={`/jobs/${job.id}`} 
//                 style={{ color: 'green', textDecoration: 'underline', cursor: 'pointer' }}
//               >
//                 GO TO JOB POST
//               </a>
//             </div>
//           </Popup>





//           </Marker>
//         );
//       })}
//     </MapContainer>
//   );
// };

// export default JobMap;



import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import L from "leaflet";

const API = process.env.REACT_APP_API_BASE_URL;

const JobMap = () => {
  const [jobs, setJobs] = useState([]);
  const [locations, setLocations] = useState({});

  // Fetch jobs

  useEffect(() => {
    axios.get(`${API}/available-jobs`)
      .then((response) => setJobs(response.data))
      .catch((err) => console.error("Error fetching jobs:", err));
  }, []);

  // Fetch city coordinates from the new API
  useEffect(() => {
    axios.get(`${API}/job-locations-coords`)
      .then((response) => {
        const locationMap = {};
        response.data.forEach(({ city_name, latitude, longitude }) => {
          if (latitude && longitude) {
            locationMap[city_name] = { lat: latitude, lng: longitude };
          }
        });
        setLocations(locationMap);
      })
      .catch((err) => console.error("Error fetching locations:", err));
  }, []);

  // Group jobs by job_location
  const jobsByLocation = {};
  jobs.forEach(job => {
    const loc = job.job_location;
    if (!jobsByLocation[loc]) {
      jobsByLocation[loc] = [];
    }
    jobsByLocation[loc].push(job);
  });

  // Function to generate a small random offset (in degrees)
  const randomOffset = () => (Math.random() - 0.5) * 0.005; // Adjust multiplier as needed

  return (
    <div className="map-wrapper">
    <MapContainer center={[43.0, 17.5]} zoom={7} style={{ height: "500px", width: "100%" }}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {Object.values(jobsByLocation).map(jobGroup =>
        jobGroup.map((job) => {
          const jobLocation = locations[job.job_location];
          if (!jobLocation) {
            console.warn(`Skipping job "${job.job_name}" - No coordinates found for: ${job.job_location}`);
            return null;
          }
          // Apply a random offset to both latitude and longitude
          const markerPosition = [
            jobLocation.lat + randomOffset(),
            jobLocation.lng + randomOffset()
          ];

          return (
            <Marker
              key={job.id}
              position={markerPosition}
              icon={L.icon({
                iconUrl: "https://leafletjs.com/examples/custom-icons/leaf-red.png",
                iconSize: [25, 41],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
              })}
            >
              <Popup>
                <div>
                  <strong style={{ color: 'green' }}>
                    {job.job_name.length > 30 
                      ? job.job_name.substring(0, 30) + '...'
                      : job.job_name}
                  </strong>
                  <br />
                  <b>Lokacija:</b> {job.job_location}
                  <br />
                  <b>Plata:</b> {job.salary} 
                  <br />
                  <a 
                    href={`/jobs/${job.id}`} 
                    style={{ color: 'green', textDecoration: 'underline', cursor: 'pointer' }}
                  >
                    POGLEDAJ POSAO
                  </a>
                </div>
              </Popup>
            </Marker>
          );
        })
      )}
    </MapContainer>
    </div>
  );
};

export default JobMap;
